import { useEffect, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import translating from '../../../translate.json';
import { find } from 'lodash';
import PropTypes from 'prop-types';

const SelectFilter = ({ field, Controller, control }) => {
  const [currentField, setCurrentField] = useState();

  useEffect(() => {
    let cf = JSON.parse(JSON.stringify(field));
    if (!cf.options) cf.options = [];
    if (!find(cf.options, { id: 'all' }))
      cf.options?.push({ id: 'all', name: translating.all });
    cf.options.reverse();
    setCurrentField(cf);
  }, []);

  return (
    <FormControl
      variant="standard"
      sx={{ m: 1, minWidth: 120 }}
      className="filter-input"
      classes={{ root: 'formControlRoot' }}
    >
      <InputLabel classes={{ root: 'labelInputRoot' }} shrink="true">
        {field?.label}
      </InputLabel>
      {(() => {
        switch (field?.isId) {
          case true:
            return (
              <Controller
                render={({ field }) => (
                  <Select
                    {...field}
                    className="filterInput"
                    classes={{ select: 'selectInput' }}
                    disableUnderline
                  >
                    {currentField?.options?.map((option, index) => (
                      <MenuItem key={index} value={option?.id}>
                        {option.name || option.text}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                control={control}
                name={field.name}
                defaultValue={'all'}
              />
            );
          default:
            return (
              <Controller
                render={({ field }) => (
                  <Select
                    {...field}
                    className="filterInput"
                    classes={{ select: 'selectInput' }}
                    disableUnderline
                  >
                    {currentField?.options?.map((option, index) => (
                      <MenuItem key={index} value={option?._id || option?.name}>
                        {option.name || option.text}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                control={control}
                name={field.name}
                defaultValue={translating.all}
              />
            );
        }
      })()}
    </FormControl>
  );
};

export default SelectFilter;

SelectFilter.propTypes = {
  field: PropTypes.object,
  Controller: PropTypes.any,
  control: PropTypes.any
};
